import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import get from 'lodash/get';
import { bool, func, number, string } from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { batch, connect } from 'react-redux';
import { ACCESS_BEING_LOADED, ACCESS_UPDATED, ASSET_PLANS, CAMPAIGN_SUBSCRIPTION_GROUP_UPDATED, METER_UPDATED, PAYMENT_OPTIONS_UPDATED, SUBSCRIPTION_GROUP_UPDATED } from '../store/actions';
import { awaitHelper } from '../utils';

var AccessTypeBase = /*#__PURE__*/function (_React$Component) {
  _inherits(AccessTypeBase, _React$Component);

  var _super = /*#__PURE__*/_createSuper(AccessTypeBase);

  function AccessTypeBase(props) {
    var _this;

    _classCallCheck(this, AccessTypeBase);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "loadScript", function (callback) {
      var accessTypeKey = get(_this.props, ['accessTypeKey']);
      var isStaging = get(_this.props, ['isStaging']);
      var enableAccesstype = get(_this.props, ['enableAccesstype']);

      if (!enableAccesstype) {
        return false;
      }

      var HOST = isStaging ? _this.stagingHost : _this.prodHost;
      var environment = isStaging ? '&env=sandbox' : '';
      var accessTypeHost = "".concat(HOST, "/frontend/v2/accesstype.js?key=").concat(accessTypeKey).concat(environment);
      var isATScriptAlreadyPresent = document.querySelector("script[src=\"".concat(accessTypeHost, "\"]"));

      if (accessTypeKey && !isATScriptAlreadyPresent && !global.AccessType && global.document) {
        var accessTypeScript = document.createElement('script');

        accessTypeScript.onload = function () {
          _this.props.onATGlobalSet && _this.props.onATGlobalSet();
          callback();
        };

        accessTypeScript.setAttribute('src', accessTypeHost);
        accessTypeScript.setAttribute('id', 'AccessTypeScript');
        accessTypeScript.setAttribute('data-accessType-script', '1');
        accessTypeScript.async = 1;
        document.body.appendChild(accessTypeScript);
        return true;
      }

      if (global.AccessType) {
        _this.props.onATGlobalSet && _this.props.onATGlobalSet();
        callback();
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "setUser", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(emailAddress, mobileNumber, accesstypeJwt) {
        var isLoggedIn,
            userObj,
            _yield$awaitHelper,
            error,
            user,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isLoggedIn = _args.length > 3 && _args[3] !== undefined ? _args[3] : true;

                if (global.AccessType) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", null);

              case 3:
                userObj = isLoggedIn ? {
                  emailAddress: emailAddress,
                  mobileNumber: mobileNumber,
                  accesstypeJwt: accesstypeJwt
                } : {
                  isLoggedIn: false
                };
                _context.next = 6;
                return awaitHelper(global.AccessType.setUser(userObj));

              case 6:
                _yield$awaitHelper = _context.sent;
                error = _yield$awaitHelper.error;
                user = _yield$awaitHelper.data;

                if (!error) {
                  _context.next = 12;
                  break;
                }

                console.warn("User context setting failed  --> ", error);
                return _context.abrupt("return", error);

              case 12:
                _this.props.onUserSet && _this.props.onUserSet();
                return _context.abrupt("return", user);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "validateCoupon", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(selectedPlanId, couponCode) {
        var _yield$awaitHelper2, error, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (global.AccessType) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", {});

              case 2:
                _context2.next = 4;
                return awaitHelper(global.AccessType.validateCoupon({
                  subscriptionPlanId: selectedPlanId,
                  couponCode: couponCode
                }));

              case 4:
                _yield$awaitHelper2 = _context2.sent;
                error = _yield$awaitHelper2.error;
                data = _yield$awaitHelper2.data;

                if (!error) {
                  _context2.next = 10;
                  break;
                }

                console.warn("Error --> ", error);
                return _context2.abrupt("return", error);

              case 10:
                return _context2.abrupt("return", data);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x4, _x5) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "cancelSubscription", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var subscriptionId,
          _args3 = arguments;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              subscriptionId = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : null;

              if (subscriptionId) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return", Promise.reject('Subscription id is not defined'));

            case 3:
              return _context3.abrupt("return", global.AccessType.cancelSubscription(subscriptionId));

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "getPath", function (sketchesHost, relativePath) {
      try {
        var _URL = new URL(sketchesHost),
            pathname = _URL.pathname;

        if (pathname && pathname !== '/') {
          return "".concat(sketchesHost).concat(relativePath);
        }

        return relativePath;
      } catch (err) {
        console.log('Sketches host path error ---> ', err);
        return relativePath;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getSubscription", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var accessTypeKey, isStaging, HOST, accessTypeHost, _yield$awaitHelper3, error, subscriptions;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              accessTypeKey = get(_this.props, ['accessTypeKey']);
              isStaging = get(_this.props, ['isStaging']);
              HOST = isStaging ? _this.stagingHost : _this.prodHost; // TODO: use AccesstypeJS method insead of direct api call

              accessTypeHost = "".concat(HOST, "/api/v1/subscription_groups.json?key=").concat(accessTypeKey);
              _context4.t0 = awaitHelper;
              _context4.next = 7;
              return global.fetch(accessTypeHost);

            case 7:
              _context4.t1 = _context4.sent.json();
              _context4.next = 10;
              return (0, _context4.t0)(_context4.t1);

            case 10:
              _yield$awaitHelper3 = _context4.sent;
              error = _yield$awaitHelper3.error;
              subscriptions = _yield$awaitHelper3.data;

              if (!error) {
                _context4.next = 15;
                break;
              }

              return _context4.abrupt("return", {
                error: 'subscriptions fetch failed'
              });

            case 15:
              return _context4.abrupt("return", subscriptions['subscription_groups'] || []);

            case 16:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));

    _defineProperty(_assertThisInitialized(_this), "getPaymentOptions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _yield$awaitHelper4, error, paymentOptions;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (global.AccessType) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt("return", []);

            case 2:
              _context5.next = 4;
              return awaitHelper(global.AccessType.getPaymentOptions());

            case 4:
              _yield$awaitHelper4 = _context5.sent;
              error = _yield$awaitHelper4.error;
              paymentOptions = _yield$awaitHelper4.data;

              if (!error) {
                _context5.next = 9;
                break;
              }

              return _context5.abrupt("return", {
                error: 'payment options fetch failed'
              });

            case 9:
              return _context5.abrupt("return", paymentOptions);

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));

    _defineProperty(_assertThisInitialized(_this), "getAssetPlans", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var storyId,
          _yield$awaitHelper5,
          error,
          _yield$awaitHelper5$d,
          assetPlans,
          _args6 = arguments;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              storyId = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : '';

              if (global.AccessType) {
                _context6.next = 3;
                break;
              }

              return _context6.abrupt("return", []);

            case 3:
              _context6.next = 5;
              return awaitHelper(global.AccessType.getAssetPlans({
                id: storyId,
                type: 'story'
              }));

            case 5:
              _yield$awaitHelper5 = _context6.sent;
              error = _yield$awaitHelper5.error;
              _yield$awaitHelper5$d = _yield$awaitHelper5.data;
              assetPlans = _yield$awaitHelper5$d === void 0 ? {} : _yield$awaitHelper5$d;

              if (!error) {
                _context6.next = 11;
                break;
              }

              return _context6.abrupt("return", {
                error: 'asset plan fetch failed'
              });

            case 11:
              return _context6.abrupt("return", assetPlans);

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    })));

    _defineProperty(_assertThisInitialized(_this), "getCampaignSubscription", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var isAccessTypeCampaignEnabled, accessTypeKey, isStaging, HOST, accessTypeHost, _yield$awaitHelper6, error, campaignSubscriptions;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              isAccessTypeCampaignEnabled = get(_this.props, ['isAccessTypeCampaignEnabled'], false);

              if (!isAccessTypeCampaignEnabled) {
                _context7.next = 18;
                break;
              }

              accessTypeKey = get(_this.props, ['accessTypeKey']);
              isStaging = get(_this.props, ['isStaging']);
              HOST = isStaging ? _this.stagingHost : _this.prodHost;
              accessTypeHost = "".concat(HOST, "/api/v1/campaigns.json?key=").concat(accessTypeKey);
              _context7.t0 = awaitHelper;
              _context7.next = 9;
              return global.fetch(accessTypeHost);

            case 9:
              _context7.t1 = _context7.sent.json();
              _context7.next = 12;
              return (0, _context7.t0)(_context7.t1);

            case 12:
              _yield$awaitHelper6 = _context7.sent;
              error = _yield$awaitHelper6.error;
              campaignSubscriptions = _yield$awaitHelper6.data;

              if (!error) {
                _context7.next = 17;
                break;
              }

              return _context7.abrupt("return", {
                error: 'subscriptions fetch failed'
              });

            case 17:
              return _context7.abrupt("return", campaignSubscriptions['subscription_groups'] || []);

            case 18:
              return _context7.abrupt("return", []);

            case 19:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    })));

    _defineProperty(_assertThisInitialized(_this), "runSequentialCalls", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var callback,
          _ref9,
          email,
          phone,
          accessTypeBkIntegrationId,
          _ref9$executeSequenti,
          executeSequentialCalls,
          jwtResponse,
          _yield$awaitHelper7,
          error,
          _args8 = arguments;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              callback = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : function () {
                return null;
              };
              _ref9 = _this.props || {}, email = _ref9.email, phone = _ref9.phone, accessTypeBkIntegrationId = _ref9.accessTypeBkIntegrationId, _ref9$executeSequenti = _ref9.executeSequentialCalls, executeSequentialCalls = _ref9$executeSequenti === void 0 ? true : _ref9$executeSequenti;
              _context8.next = 4;
              return fetch("/api/auth/v1/access-token/integrations/".concat(accessTypeBkIntegrationId));

            case 4:
              jwtResponse = _context8.sent;
              _context8.next = 7;
              return awaitHelper(_this.setUser(email, phone, jwtResponse.headers.get('x-integration-token'), !!jwtResponse.headers.get('x-integration-token')));

            case 7:
              _yield$awaitHelper7 = _context8.sent;
              error = _yield$awaitHelper7.error;

              if (!error) {
                try {
                  if (executeSequentialCalls) {
                    Promise.all([_this.getSubscription(), _this.getPaymentOptions(), _this.getAssetPlans(), _this.getCampaignSubscription()]).then(function (_ref10) {
                      var _ref11 = _slicedToArray(_ref10, 4),
                          subscriptionGroups = _ref11[0],
                          paymentOptions = _ref11[1],
                          assetPlans = _ref11[2],
                          campaignSubscriptionGroups = _ref11[3];

                      batch(function () {
                        _this.props.subscriptionGroupLoaded(subscriptionGroups);

                        _this.props.paymentOptionsLoaded(paymentOptions);

                        _this.props.assetPlanLoaded(assetPlans);

                        _this.props.campaignSubscriptionGroupLoaded(campaignSubscriptionGroups);
                      });
                      callback();
                    });
                  } else {
                    callback();
                  }
                } catch (e) {
                  console.log("Subscription / payments failed", e);
                }
              }

            case 10:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    })));

    _defineProperty(_assertThisInitialized(_this), "getSubscriptionForUser", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var _yield$awaitHelper8, error, _yield$awaitHelper8$d, subscriptions;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (global.AccessType) {
                _context9.next = 2;
                break;
              }

              return _context9.abrupt("return", {});

            case 2:
              _context9.next = 4;
              return awaitHelper(global.AccessType.getSubscriptions());

            case 4:
              _yield$awaitHelper8 = _context9.sent;
              error = _yield$awaitHelper8.error;
              _yield$awaitHelper8$d = _yield$awaitHelper8.data;
              subscriptions = _yield$awaitHelper8$d === void 0 ? [] : _yield$awaitHelper8$d;

              if (!error) {
                _context9.next = 10;
                break;
              }

              return _context9.abrupt("return", error);

            case 10:
              return _context9.abrupt("return", subscriptions);

            case 11:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    })));

    _defineProperty(_assertThisInitialized(_this), "getSubscriptionsWithSwitchablePlans", /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(planId) {
        var _yield$awaitHelper9, error, _yield$awaitHelper9$d, subscription;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (global.AccessType) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt("return", {});

              case 2:
                if (planId) {
                  _context10.next = 4;
                  break;
                }

                throw new Error('planId is mandatory');

              case 4:
                _context10.next = 6;
                return awaitHelper(global.AccessType.getSubscriptionWithSwitchablePlans(planId, 'switch'));

              case 6:
                _yield$awaitHelper9 = _context10.sent;
                error = _yield$awaitHelper9.error;
                _yield$awaitHelper9$d = _yield$awaitHelper9.data;
                subscription = _yield$awaitHelper9$d === void 0 ? {} : _yield$awaitHelper9$d;

                if (!error) {
                  _context10.next = 12;
                  break;
                }

                return _context10.abrupt("return", error);

              case 12:
                return _context10.abrupt("return", subscription);

              case 13:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x6) {
        return _ref13.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "initAccessType", function (callback) {
      var accessTypeBkIntegrationId = _this.props.accessTypeBkIntegrationId;

      try {
        _this.loadScript(function () {
          // dont try to initialize accessType if integration id is not available
          if (accessTypeBkIntegrationId === undefined) {
            console.warn('AccessType: Integration Id is undefined');
            return false;
          }

          _this.runSequentialCalls(callback);
        });
      } catch (e) {
        console.warn("Accesstype load fail", e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "initRazorPayPayment", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var selectedPlanObj,
          planType,
          storyId,
          storyHeadline,
          storySlug,
          paymentType,
          opts,
          intent,
          switchType,
          planObject,
          paymentOptions,
          _planObject$selectedP,
          discounted_price_cents,
          price_cents,
          paymentObject,
          _yield$awaitHelper10,
          data,
          _yield$awaitHelper11,
          error,
          switchPaymentOptions,
          _args11 = arguments;

      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              selectedPlanObj = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
              planType = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : '';
              storyId = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : '';
              storyHeadline = _args11.length > 3 && _args11[3] !== undefined ? _args11[3] : '';
              storySlug = _args11.length > 4 && _args11[4] !== undefined ? _args11[4] : '';
              paymentType = _args11.length > 5 && _args11[5] !== undefined ? _args11[5] : '';
              opts = _args11.length > 6 ? _args11[6] : undefined;

              if (selectedPlanObj) {
                _context11.next = 10;
                break;
              }

              console.warn('Razor pay needs a plan');
              return _context11.abrupt("return", false);

            case 10:
              intent = get(opts, ['intent'], 'default');
              switchType = get(opts, ['switchType']);
              planObject = _this.makePlanObject(selectedPlanObj, planType, storyId, storyHeadline, storySlug); //we are doing this to sake of backward compatibility and will be refactored later.

              planObject['paymentType'] = paymentType || (get(planObject, ['selectedPlan', 'recurring']) ? 'razorpay_recurring' : 'razorpay');
              paymentOptions = _this.props.paymentOptions;
              _planObject$selectedP = planObject.selectedPlan, discounted_price_cents = _planObject$selectedP.discounted_price_cents, price_cents = _planObject$selectedP.price_cents;
              paymentObject = _this.makePaymentObject(_objectSpread(_objectSpread({}, planObject), {}, {
                couponCode: selectedPlanObj.coupon_code
              }));

              if (!(discounted_price_cents === 0 || price_cents === 0)) {
                _context11.next = 23;
                break;
              }

              _context11.next = 20;
              return awaitHelper(global.AccessType.getPaymentOptions(0));

            case 20:
              _yield$awaitHelper10 = _context11.sent;
              data = _yield$awaitHelper10.data;
              paymentOptions = data;

            case 23:
              if (!(paymentObject.payment.amount_cents === 0)) {
                _context11.next = 25;
                break;
              }

              return _context11.abrupt("return", global.AccessType.getPaymentOptions(0).then(function (provider) {
                return provider.razorpay.proceed(paymentObject);
              }));

            case 25:
              if (!(intent === 'switch')) {
                _context11.next = 34;
                break;
              }

              _context11.next = 28;
              return awaitHelper(global.AccessType.getPaymentOptions(null, null, 'switch'));

            case 28:
              _yield$awaitHelper11 = _context11.sent;
              error = _yield$awaitHelper11.error;
              switchPaymentOptions = _yield$awaitHelper11.data;

              if (!error) {
                _context11.next = 33;
                break;
              }

              throw new Error('payment options fetch failed');

            case 33:
              return _context11.abrupt("return", switchPaymentOptions.razorpay.proceed(_objectSpread(_objectSpread({}, paymentObject), {}, {
                switch_type: switchType,
                subscription_plan_id: selectedPlanObj.id,
                subscriptionId: selectedPlanObj.subscriptionId
              })));

            case 34:
              return _context11.abrupt("return", paymentOptions.razorpay.proceed(paymentObject));

            case 35:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    })));

    _defineProperty(_assertThisInitialized(_this), "initStripePayment", function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!options.selectedPlan) {
        console.warn('Stripe pay needs a plan');
        return false;
      }

      var paymentOptions = _this.props.paymentOptions;
      var paymentType = get(options.selectedPlan, ['recurring']) ? 'stripe_recurring' : 'stripe';

      var paymentObject = _this.makePaymentObject(_objectSpread({
        paymentType: paymentType
      }, options));

      return paymentOptions.stripe ? paymentOptions.stripe.proceed(paymentObject) : Promise.reject({
        message: 'Payment option is loading...'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "initPaypalPayment", function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!options.selectedPlan) {
        console.warn('Paypal pay needs a plan');
        return false;
      }

      var paymentOptions = _this.props.paymentOptions;
      var paymentType = get(options.selectedPlan, ['recurring']) ? 'paypal_recurring' : 'paypal';

      var paymentObject = _this.makePaymentObject(_objectSpread({
        paymentType: paymentType
      }, options));

      return paymentOptions.paypal ? paymentOptions.paypal.proceed(paymentObject).then(function (response) {
        return response.proceed(paymentObject);
      }) : Promise.reject({
        message: 'Payment option is loading...'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "initOmisePayment", function () {
      var selectedPlanObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var planType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (!selectedPlanObj) {
        console.warn('Omise pay needs a plan');
        return false;
      }

      var planObject = _this.makePlanObject(selectedPlanObj, planType);

      planObject['paymentType'] = get(planObject, ['selectedPlan', 'recurring']) ? 'omise_recurring' : 'omise';

      var paymentObject = _this.makePaymentObject(planObject);

      var omise = get(_this.props, ['paymentOptions', 'omise']);

      if (!omise) {
        return Promise.reject({
          message: 'Payment option is loading...'
        });
      }

      return omise.proceed(paymentObject).then(function (response) {
        return response;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "initAdyenPayment", function () {
      var selectedPlanObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var planType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var AdyenModal = arguments.length > 2 ? arguments[2] : undefined;
      var locale = arguments.length > 3 ? arguments[3] : undefined;

      var adyenExecutor = function adyenExecutor(resolve, reject) {
        if (!document.getElementById('adyen-modal')) {
          var modalElement = document.createElement('div');
          modalElement.setAttribute('id', 'adyen-modal');
          document.body.appendChild(modalElement);
        }

        var afterOpen = function afterOpen() {
          var planObject = _this.makePlanObject(selectedPlanObj, planType);

          var isRecurring = get(planObject, ['selectedPlan', 'recurring']);
          var paymentType = isRecurring ? 'adyen_recurring' : 'adyen';

          var paymentObject = _this.makePaymentObject(_objectSpread(_objectSpread({}, planObject), {}, {
            paymentType: paymentType
          }));

          var adyen = get(_this.props, ['paymentOptions', 'adyen']);
          paymentObject = _objectSpread(_objectSpread({}, paymentObject), {}, {
            options: _objectSpread(_objectSpread({}, paymentObject['options']), {}, {
              dropin_container_id: 'dropin-adyen',
              locale: locale
            }),
            additional_data: {
              publisher_return_url: "".concat(document.location.origin, "/user-details")
            }
          });
          return resolve(adyen.proceed(paymentObject).then(function (response) {
            return response.proceed(paymentObject);
          }));
        };

        ReactDOM.render( /*#__PURE__*/React.createElement(AdyenModal, {
          afterOpen: afterOpen,
          afterClose: reject
        }), document.getElementById('adyen-modal'));
      };

      return new Promise(adyenExecutor);
    });

    _defineProperty(_assertThisInitialized(_this), "initPaytrailPayment", function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!options.selectedPlan) {
        console.warn('Paytrail needs a plan');
        return false;
      }

      var paymentOptions = _this.props.paymentOptions;
      var paymentType = get(options.selectedPlan, ['recurring']) ? 'paytrail_recurring' : 'paytrail';

      var paymentObject = _this.makePaymentObject(_objectSpread({
        paymentType: paymentType
      }, options));

      return paymentOptions.paytrail ? paymentOptions.paytrail.proceed(paymentObject).then(function (response) {
        return response.proceed(paymentObject);
      }) : Promise.reject({
        message: 'Payment option is loading...'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "pingBackMeteredStory", /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(asset, accessData) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                try {
                  global.AccessType.pingbackAssetAccess(asset, accessData);
                } catch (e) {
                  console.log('error in pingbackAssetAccess', e);
                }

                return _context12.abrupt("return", true);

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function (_x7, _x8) {
        return _ref15.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "checkAccess", /*#__PURE__*/function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(assetId) {
        var asset, _yield$awaitHelper12, error, accessData, accessById, _ref17, granted, grantReason, _ref17$data, data;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (assetId) {
                  _context13.next = 3;
                  break;
                }

                console.warn('AssetId is required');
                return _context13.abrupt("return", false);

              case 3:
                _this.props.accessIsLoading(true);

                asset = {
                  id: assetId,
                  type: 'story'
                };
                _context13.next = 7;
                return awaitHelper(global.AccessType.isAssetAccessible(asset, _this.props.disableMetering));

              case 7:
                _yield$awaitHelper12 = _context13.sent;
                error = _yield$awaitHelper12.error;
                accessData = _yield$awaitHelper12.data;

                if (!error) {
                  _context13.next = 12;
                  break;
                }

                return _context13.abrupt("return", error);

              case 12:
                accessById = _defineProperty({}, assetId, accessData);

                _this.props.accessUpdated(accessById);

                _this.props.accessIsLoading(false);

                _ref17 = accessData || {}, granted = _ref17.granted, grantReason = _ref17.grantReason, _ref17$data = _ref17.data, data = _ref17$data === void 0 ? {} : _ref17$data;

                if (!_this.props.disableMetering && granted && grantReason === 'METERING') {
                  _this.pingBackMeteredStory(asset, accessData);

                  _this.props.meterUpdated(data.numberRemaining || -1);
                }

                return _context13.abrupt("return", accessById);

              case 18:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      return function (_x9) {
        return _ref16.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "getSubscriberMetadata", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
      var metadata;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              if (global.AccessType) {
                _context14.next = 2;
                break;
              }

              return _context14.abrupt("return", {});

            case 2:
              _context14.next = 4;
              return awaitHelper(global.AccessType.getSubscriberMetadata());

            case 4:
              metadata = _context14.sent;
              return _context14.abrupt("return", metadata);

            case 6:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    })));

    _defineProperty(_assertThisInitialized(_this), "setSubscriberMetadata", /*#__PURE__*/function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(subscriberMetadata) {
        var response;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(!global.AccessType || !subscriberMetadata)) {
                  _context15.next = 2;
                  break;
                }

                return _context15.abrupt("return", {});

              case 2:
                _context15.next = 4;
                return awaitHelper(global.AccessType.setSubscriberMetadata(subscriberMetadata));

              case 4:
                response = _context15.sent;
                return _context15.abrupt("return", response);

              case 6:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      return function (_x10) {
        return _ref19.apply(this, arguments);
      };
    }());

    _this.prodHost = props.prodHost || 'https://www.accesstype.com';
    _this.stagingHost = props.stagingHost || 'https://staging.accesstype.com';
    return _this;
  }

  _createClass(AccessTypeBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initAccessType();
    }
  }, {
    key: "makePaymentObject",
    value: function makePaymentObject(_ref20) {
      var _ref20$selectedPlan = _ref20.selectedPlan,
          selectedPlan = _ref20$selectedPlan === void 0 ? {} : _ref20$selectedPlan,
          _ref20$couponCode = _ref20.couponCode,
          couponCode = _ref20$couponCode === void 0 ? '' : _ref20$couponCode,
          _ref20$recipientSubsc = _ref20.recipientSubscriber,
          recipientSubscriber = _ref20$recipientSubsc === void 0 ? {} : _ref20$recipientSubsc,
          _ref20$planType = _ref20.planType,
          planType = _ref20$planType === void 0 ? '' : _ref20$planType,
          _ref20$storyId = _ref20.storyId,
          storyId = _ref20$storyId === void 0 ? '' : _ref20$storyId,
          _ref20$storyHeadline = _ref20.storyHeadline,
          storyHeadline = _ref20$storyHeadline === void 0 ? '' : _ref20$storyHeadline,
          _ref20$storySlug = _ref20.storySlug,
          storySlug = _ref20$storySlug === void 0 ? '' : _ref20$storySlug,
          _ref20$paymentType = _ref20.paymentType,
          paymentType = _ref20$paymentType === void 0 ? '' : _ref20$paymentType,
          _ref20$successUrl = _ref20.successUrl,
          successUrl = _ref20$successUrl === void 0 ? '' : _ref20$successUrl,
          _ref20$returnUrl = _ref20.returnUrl,
          returnUrl = _ref20$returnUrl === void 0 ? '' : _ref20$returnUrl,
          _ref20$cancelUrl = _ref20.cancelUrl,
          cancelUrl = _ref20$cancelUrl === void 0 ? '' : _ref20$cancelUrl;
      var id = selectedPlan.id,
          title = selectedPlan.title,
          description = selectedPlan.description,
          price_cents = selectedPlan.price_cents,
          price_currency = selectedPlan.price_currency,
          duration_length = selectedPlan.duration_length,
          duration_unit = selectedPlan.duration_unit,
          discounted_price_cents = selectedPlan.discounted_price_cents,
          metadata = selectedPlan.metadata;
      var paymentObject = {
        type: planType,
        plan: {
          id: id,
          title: title,
          description: description,
          price_cents: price_cents,
          price_currency: price_currency,
          duration_length: duration_length,
          duration_unit: duration_unit,
          discounted_price_cents: discounted_price_cents
        },
        metadata: metadata,
        coupon_code: couponCode,
        payment: {
          payment_type: paymentType,
          amount_cents: discounted_price_cents === undefined ? price_cents : discounted_price_cents,
          amount_currency: price_currency
        },
        assets: [{
          id: storyId,
          title: storyHeadline,
          slug: storySlug
        }],
        recipient_subscriber: recipientSubscriber //for gift subscription

      };

      if ((successUrl || returnUrl) && cancelUrl) {
        paymentObject.options = {};
        paymentObject.options.urls = {
          cancel_url: cancelUrl
        };

        if (returnUrl) {
          paymentObject.options.urls['return_url'] = returnUrl;
        } else {
          paymentObject.options.urls['success_url'] = successUrl;
        }
      }

      return paymentObject;
    }
  }, {
    key: "makePlanObject",
    value: function makePlanObject() {
      var selectedPlanObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var planType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var storyId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var storyHeadline = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var storySlug = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
      return selectedPlanObj.argType && selectedPlanObj.argType === 'options' ? {
        selectedPlan: selectedPlanObj.selectedPlan,
        planType: selectedPlanObj.planType,
        storyId: selectedPlanObj.storyId,
        storyHeadline: selectedPlanObj.storyHeadline,
        storySlug: selectedPlanObj.storySlug,
        couponCode: selectedPlanObj.couponCode,
        recipientSubscriber: selectedPlanObj.recipientSubscriber
      } : {
        selectedPlan: selectedPlanObj,
        planType: planType,
        storyId: storyId,
        storyHeadline: storyHeadline,
        storySlug: storySlug
      };
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        initAccessType: this.initAccessType,
        initRazorPayPayment: this.initRazorPayPayment,
        initStripePayment: this.initStripePayment,
        initPaypalPayment: this.initPaypalPayment,
        initOmisePayment: this.initOmisePayment,
        initAdyenPayment: this.initAdyenPayment,
        initPaytrailPayment: this.initPaytrailPayment,
        checkAccess: this.checkAccess,
        getSubscription: this.getSubscription,
        getSubscriptionsWithSwitchablePlans: this.getSubscriptionsWithSwitchablePlans,
        getSubscriptionForUser: this.getSubscriptionForUser,
        accessUpdated: this.props.accessUpdated,
        accessIsLoading: this.props.accessIsLoading,
        getAssetPlans: this.props.getAssetPlans,
        validateCoupon: this.validateCoupon,
        cancelSubscription: this.cancelSubscription,
        getSubscriberMetadata: this.getSubscriberMetadata,
        setSubscriberMetadata: this.setSubscriberMetadata
      });
    }
  }]);

  return AccessTypeBase;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    subscriptions: state.subscriptions || null,
    paymentOptions: state.paymentOptions || null,
    assetPlans: state.assetPlans || null
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    subscriptionGroupLoaded: function subscriptionGroupLoaded(subscriptions) {
      return dispatch({
        type: SUBSCRIPTION_GROUP_UPDATED,
        subscriptions: subscriptions
      });
    },
    paymentOptionsLoaded: function paymentOptionsLoaded(paymentOptions) {
      return dispatch({
        type: PAYMENT_OPTIONS_UPDATED,
        paymentOptions: paymentOptions
      });
    },
    accessIsLoading: function accessIsLoading(loading) {
      return dispatch({
        type: ACCESS_BEING_LOADED,
        loading: loading
      });
    },
    accessUpdated: function accessUpdated(access) {
      return dispatch({
        type: ACCESS_UPDATED,
        access: access
      });
    },
    meterUpdated: function meterUpdated(meterCount) {
      return dispatch({
        type: METER_UPDATED,
        meterCount: meterCount
      });
    },
    assetPlanLoaded: function assetPlanLoaded(assetPlans) {
      return dispatch({
        type: ASSET_PLANS,
        assetPlans: assetPlans
      });
    },
    campaignSubscriptionGroupLoaded: function campaignSubscriptionGroupLoaded(campaignSubscriptions) {
      return dispatch({
        type: CAMPAIGN_SUBSCRIPTION_GROUP_UPDATED,
        campaignSubscriptions: campaignSubscriptions
      });
    }
  };
};
/**
 * `AccessType` is a generic connected render prop which exposes methods to handle access to stories / assets and initialize AccessTypeJS.

 *
 *   Name | arguments | Description
 *  --- | --- | ---
 *  initAccessType| -NA- | Initializes accesstype, checks for existance of accesstype before requesting for AT js
 *  initRazorPayPayment| selectedPlan(object), planType(string) | Executes accesstype js method to bring forth RP payment gateway
 *  initStripePayment| options(object), options={ argType: "options",selectedPlan: selectedPlanObj, planType:"",couponCode: "", successUrl:"", cancelUrl:"", recipientSubscriber: {}} | Initialize the Stripe payment
 *  initPaypalPayment| options(object), options={argType: "options",selectedPlan: selectedPlanObj,planType: planType,couponCode: "", recipientSubscriber: {}, returnUrl: "",cancelUrl:""} | Initialize the PayPal payment
 *  initOmisePayment| selectedPlan(object), planType(string)  | Initialize the Omise payment
 *  initAdyenPayment| selectedPlan(object), planType(string), AdyenModal(React Component), locale(string) | Initialize Adyen Payment
 *  initPaytrailPayment| selectedPlan(object), ptions={selectedPlan: selectedPlanObj,planType: planType,couponCode: "", recipientSubscriber: {}, returnUrl: "",cancelUrl:""} | Initialize the Paytrail payment
 *  getAssetPlans| storyId(string) | Get Asset Subscription Plans
 *  getSubscriberMetadata| Get the Subscriber Metadata
 *  setSubscriberMetadata| subscriberMetadata(object), subscriberMetadata={"address": {
      "line1": "221B Bakers Street",
      "line2": "Near Watson Library",
      "city": "London",
      "state": "",
  },
  "phone_number": "007"}}  | Update the Subscriber Metadata
 *  validateCoupon|  selectedPlan(object), couponCode (string)  | Validate coupon with plan
 *  cancelSubscription| subscriptionId(number) | Cancel a subscription
 *  getSubscription | -NA- | Gets the subscription groups provided by the publisher
 *  getSubscriptionForUser | -NA- | Gets the subscriptions of the current logged in user
 *  accessUpdated| accessObject(object) | Sets the current story access to redux store
 *  accessIsLoading| loading(boolean) | A boolean which holds true between the request for access of a story and its response
 *
 * ###### Notes :
 *
 * * This component uses AccessType Js internally
 * * It uses the Access API from subtype for metering, the API works on firebase which uses `thinmint` cookie (set by qlitics) of the user to verify and keep track of visits
 * * This component  supports Razorpay, Stripe, PayPal and Omise payment options for now
 * * It communicates to sketches where routes are in pattern `/api/access/v1/*`
 * * Metered story has a pingback which is achieved by the use of `navigator.sendBeacon` if available or falls back to fetch, this is needed to update the count of the visited stories for a user
 * * Access to story/asset is saved on the redux store under the keyword access which holds keys as story asset id and the access returned from the API as its value
 * * `subscriptions` is the key in the store under which all the subscription groups created for the specified account are maintained
 * * `paymentOptions` is the key under the store which has all the payment options created for the current AT account
 *
 * ```javascript
 * //access object on store
 *
 * access : {
 *   'c1f6c0d7-2829-4d31-b673-58728f944f82': {
 *         'data': {
 *           'isLoggedIn':true,
 *           'granted': false
 *           'grantReason': "SUBSCRIBER"
 *         }
 *     }
 * }
 * ```
 *
 * Example
 * ```javascript
 * import { AccessType } from "@quintype/components";
 *
 * render() {
 *   return  <AccessType
 *                  enableAccesstype={enableAccesstype}
 *                  isStaging={isStaging}
 *                  accessTypeKey={accessTypeKey}
 *                  email={email}
 *                  phone={phone}
 *                  disableMetering={disableMetering}
 *                  prodHost="https://www.accesstype.com"
 *                  stagingHost="https://staging.accesstype.com"
 *                  accessTypeBkIntegrationId={accessTypeBkIntegrationId}
 *                >
 *                  {({ initAccessType, checkAccess, accessUpdated, accessIsLoading, validateCoupon, initRazorPayPayment, initStripePayment, initPaypalPayment, initPaytrailPayment,  getSubscriptionForUser, getSubscriberMetadata, setSubscriberMetadata }) => (
 *                    <div>
 *                      <PaymentCheckoutLayout
 *                        accessIsLoading={accessIsLoading}
 *                        accessUpdated={accessUpdated}
 *                        initAccessType={initAccessType}
 *                        checkAccess={checkAccess}
 *                        initRazorPayPayment={initRazorPayPayment}
 *                        initStripePayment={initStripePayment}
 *                        initPaypalPayment={initPaypalPayment}
 *                        initPaytrailPayment={initPaytrailPayment}
 *                        getSubscriptionForUser={getSubscriptionForUser}
 *                        getgetSubscriberMetadata={getgetSubscriberMetadata}
 *                        setSubscriberMetadata={setSubscriberMetadata}
 *
 *                        {...this.props}
 *                      />
 *                    </div>
 *                  )}
 *                </AccessType>
 * }
 *
 * ...
 *
 * const PaymentCheckoutLayout = (props) => {
 *
 *  useEffect(() => {
 *     !global.AccessType && initAccessType(); // initialize accesstype
 *   }, []);
 *
 *   ....
 *
 *  checkout(plan = {}) {

 *   const paymentGateway = get(plan, ["supported_payment_providers", 0], "razorpay");
 *
 *   if (paymentGateway === "razorpay") {
 *     return props.initRazorPayPayment(plan, "standard");
 *   }
 *
 *   if (paymentGateway === "paypal") {
 *     const options = {
 *       selectedPlan: plan,
 *       planType: "standard",
 *       returnUrl: `${document.location.origin}/paypal-return-url`,
 *       cancelUrl: `${document.location.origin}/paypal-cancel-url`
 *     };
 *     return props.initPaypalPayment(options);
 *   }
 *
 *  if (paymentGateway === "paytrail") {
 *     const options = {
 *       selectedPlan: plan,
 *       planType: "standard",
 *       returnUrl: `${document.location.origin}/paytrail-success.html`,
 *       cancelUrl: `${document.location.origin}/paytrail-cancel.html`
 *     };
 *     return props.initPaytrailPayment(options);
 *   }
 *
 *   if (paymentGateway === "omise") {
 *     return props.initOmisePayment(plan, "standard");
 *   }
 *
 *   if (paymentGateway === "stripe") {
 *     const options = {
 *       selectedPlan: plan,
 *       planType: "standard",
 *       successUrl: `${document.location.origin}/paypal-return-url`,
 *       cancelUrl: `${document.location.origin}/paypal-cancel-url`
 *     };
 *     return props.initPaypalPayment(options);
 *   }
 *
 *   if (paymentGateway === "adyen") {
 *     const locale = get(this.props, ["config", "pagebuilder-config", "general", "accesstypeIntegration"]);
 *     // The AdyenModal component should accept two functions as props: `afterOpen` and `afterClose`
 *     // `afterOpen` will trigger the adyen payment.
 *     return this.props.initAdyenPayment(plan, "standard", AdyenModal, locale);
 *   }
 *
 * ....
 *
 *  return (){
 *
 *    <Button onClick={() => checkout(plan)}  disabled={isLoading}>
 *      {isLoading ? <Loader /> : "SUBSCRIBE"}
 *    </Button>
 *  }
 * }
 *
 *
 * ```
 * @component
 * @category Subscription
 */


export var AccessType = /*#__PURE__*/connect(mapStateToProps, mapDispatchToProps)(AccessTypeBase);